var lib_core = require("lib-core");
var IpcSmdPadGeneratorWithThermalPadInteractionModel = require('../ipcSmdPadGeneratorWithThermalPadInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var SoicSopPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorWithThermalPadInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(SoicSopPadGeneratorInteractionModel, IpcSmdPadGeneratorWithThermalPadInteractionModel);
SoicSopPadGeneratorInteractionModel.$class = 'SoicSopPadGeneratorInteractionModel';
module.exports = SoicSopPadGeneratorInteractionModel;

SoicSopPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintSoic));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadSpan1InCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyOffset());
    imElements = imElements.concat(this.getInspectorElementsForThermalPadSettings());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};